// React & React Router
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

// Form Handling
import { useForm } from "react-hook-form";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { addNewBannerFunc } from "../../../../store/custom-actions/banners/AddBannerSlicer";

// UI Components
import PageTitle from "../../../layouts/PageTitle";
import FormField from "../../../components/ui/FormField";
import TextAreaField from "../../../components/ui/TextAreaField";
import MediaSelectorButton from "../../../components/media/MediaSelectorButton";
import SubmitButton from "../../../components/ui/SubmitButton";
import CheckboxField from "../../../components/ui/CheckboxField";
import SelectBox from "../../../components/ui/SelectBox";

function NewBannerForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: "",
      description: "",
      btn_text: "",
      link: "",
      position: "",
      mobile_image: null,
      image: null,
      is_active: 1,
    },
  });

  const { loading: submitLoading } = useSelector(
    (state) => state.addNewBannerSlicer,
  );

  const onSubmit = async (data) => {
    const result = await dispatch(addNewBannerFunc({ data }));
    if (addNewBannerFunc.fulfilled.match(result)) {
      reset();
      navigate("/banners-settings");
    }
  };

  return (
    <>
      <PageTitle
        motherMenu="Home"
        activeMenu="New Banner"
        customClasses="my-0"
      />

      {/* Top Right Buttons */}
      <div className="relative flex items-center justify-end my-3">
        <Link to="/banners-settings">
          <button type="button" className="btn btn-secondary sw-btn-back me-2">
            Back
          </button>
        </Link>
        <SubmitButton isLoading={submitLoading} form="submit-form" />
      </div>

      {/* Main Form */}
      <div className="col">
        <div className="card p-4">
          <form id="submit-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="form-group mb-3 col-md-6">
                <FormField
                  label="Title"
                  name="title"
                  register={register}
                  errors={errors}
                />
              </div>
              <div className="form-group mb-3 col-md-6">
                <FormField
                  label="Button Text"
                  name="btn_text"
                  register={register}
                  errors={errors}
                />
              </div>
              <div className="form-group mb-3 col-md-6">
                <FormField
                  label="Path Link"
                  name="link"
                  register={register}
                  errors={errors}
                />
              </div>
              <div className="form-group mb-3 col-md-6">
                <SelectBox
                  label="Position"
                  name="position"
                  register={register}
                  required={true}
                  errors={errors}
                  showLabel={true}
                  placeholder={t("Select banner position")}
                  data={[
                    { id: "top_home", name: t("Top Home") }
                  ]}
                />
              </div>
              <div className="form-group mb-3 col-12">
                <CheckboxField
                  name="is_active"
                  label="Activity"
                  register={register}
                  errors={errors}
                />
              </div>
            </div>

            <div className="row">
              <div className="form-group mb-3 col-12">
                <TextAreaField
                  label="Description"
                  name="description"
                  isRichTextEditor
                  register={register}
                  errors={errors}
                  watch={watch}
                  setValue={setValue}
                />
              </div>
            </div>

            <div className="row">
              <div className="form-group mb-3 col-md-6">
                <MediaSelectorButton
                  label="Banner Image"
                  inputName="image"
                  required
                  register={register}
                  errors={errors}
                  onChange={(val) => setValue("image", val)}
                />
              </div>
              <div className="form-group mb-3 col-md-6">
                <MediaSelectorButton
                  label="Banner Mobile Image"
                  inputName="mobile_image"
                  required
                  register={register}
                  errors={errors}
                  onChange={(val) => setValue("mobile_image", val)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default NewBannerForm;
